import _ from 'lodash';

export const getTermsUrl = (market, version = 2) => {
    if (!_.includes(['sk', 'cz'], market)) {
        market = 'en';
    }

    const version_suffix = version > 1 ? `-v${version}` : '';

    return `/terms-${market}${version_suffix}.html`;
};
